
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import banner from '../pics/banner.PNG';
import trackOrder from '../pics/track_order.PNG';
import washdryironfold from '../pics/washdryironfold.PNG';
import washDryFold from '../pics/washdryfold.PNG';
import priceList from '../pics/pricelisticon.png'
import profile from '../pics/profile_.PNG';
import logout from '../pics/logout.PNG';
import ironFoldonly from '../pics/Ironandfold.PNG';
import Logout from '../Logout/Logout';
import { FaWhatsapp } from 'react-icons/fa';
import About from '../About/About';
import { isLoggedIn } from '../Utils/Utils';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import maleIcon from '../pics/maleProfileIcon.png';
import femaleIcon from '../pics/femaleProfileIcon.png';
import { LayoutDashboard, Menu } from 'lucide-react';
//import { ArrowRightCircle, ArrowRightCircleFill } from 'react-bootstrap-icons';
import { BsPencil } from 'react-icons/bs';
import { Fa500Px, FaPlusSquare } from "react-icons/fa";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { MdOutlinePriceChange } from "react-icons/md";
import { GrStatusGood } from "react-icons/gr";
import { GrView } from "react-icons/gr";
//import { redirect } from 'next/dist/server/api-utils';
class Home extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogOutOpen = React.createRef()
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            area: "",
            token: "",
            role: "",
            address: "",
            city: "",
            userid: "",
            gender: "",
            initials: this.props.location.state && this.props.location.state.fullname ? this.props.location.state.fullname.split(" ").map(name => name.charAt(0)).join("") : ""
        }
    }

    componentDidMount = async () => {
        // console.log("gender: " + this.props.location.state.gender)

        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role,
                address: this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, gender: this.props.location.state.gender
            })

            if (this.props.location.state.role.includes('Admin')) {

                document.getElementById('viewEditOrders').style.display = "block";
            }
        }
    }

    goToWashDryFold = (e) => {
        e.preventDefault();
        this.props.navigate('/washdryfold', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender

            }
        });
    }

    goToWashDryIron = (e) => {
        e.preventDefault();
        this.props.navigate('/washdryiron', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender

            }
        });
    }

    goToIronFoldOnly = (e) => {
        e.preventDefault();
        this.props.navigate('/ironfoldonly', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender

            }
        });
    }

    goToOrders = (e) => {
        e.preventDefault();
        this.props.navigate('/orders', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender
            }
        });
    }
    goToDashboard = (e) => {
        e.preventDefault();
        this.props.navigate('/dashboard', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender
            }
        });
    }

    goToPricelist = (e) => {
        e.preventDefault();
        this.props.navigate('/pricelist', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender
            }
        });
    }

    goToTrackOrder = (e) => {
        e.preventDefault();
        this.props.navigate('/trackorder', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender
            }
        });
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    openLogOut = (e) => {
        this.handleLogOutOpen.current.handleLogOutOpen();
    }

    confirmLogout = () => {
        // Perform logout actions here (e.g., clearing tokens, redirecting)
        localStorage.removeItem("token");
        this.setState({ open: false });
        this.props.navigate('/', {
            state: {
            }
        });
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px",
                    fontFamily: "lora" //backgroundColor: "#e0ded5",
                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid white', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold", textShadow: "2px 2px 4px #000000" }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>Welcome {(this.state.fullname).split(" ")[0]} </label></span><br /> */}
                            <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span>
                            <span style={{ position: "absolute", right: "50px", paddingTop: "100px" }}>
                                <RiLogoutCircleRLine size={40} color='orange' onClick={() => this.openLogOut()} />
                            </span>

                        </div>
                    </div>
                    <div style={{ paddingTop: "8px", textAlign: "center", color: "#0c0b07ff", width: "100%" }}>
                        <div style={{ width: "50%", float: "left" }}>
                            <Button style={{
                                border: "none", cursor: "default", display: "flex", backgroundColor: "white", textShadow: "1px 1px 2px grey",
                                paddingTop: "2vh", height: "60px", width: "100%", borderRadius: "10px", //backgroundColor: "#e0ded5",
                            }} ><Menu color="white" size={35} color='darkblue' /><label style={{ color: "darkblue", fontSize: "20px", fontWeight: "bold" }}> Menu</label>
                            </Button>
                        </div>
                        <div style={{ paddingLeft: '30%', width: '50%', top: '-1px', right: '-1px', overflow: 'hidden', position: 'relative', textAlign: "center" }}>
                            <img src={this.props.location.state.gender === 'Male' ? maleIcon : femaleIcon} alt="Profile"
                                style={{ borderRadius: '50%', width: '65px', height: '65px', border: '1px solid lightblue' }} />
                            <div style={{ position: 'absolute', top: '50%', left: '80%', transform: 'translate(-50%, -50%)' }}>
                                <span style={{ fontStyle: "italic", fontsize: "14px", color: "darkblue" }}>{this.state.initials}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ paddingTop: "8px", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%",
                            backgroundColor: "beige", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                            paddingTop: "20px", textShadow: "1px 1px 2px grey",
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToIronFoldOnly}>
                            <label ><FaPlusSquare size={40} /> IRON - FOLD ONLY</label></span>
                    </div>
                    <div style={{ paddingTop: "1px", display: "flex", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey", paddingTop: "20px", textShadow: "1px 1px 2px grey",
                            borderRadius: "25px", paddingLeft: "5px", width: "100%", height: "100px", display: "inline-grid",
                            backgroundColor: "#FAF9F6", fontWeight: "bold", color: "darkblue", fontSize: "18px", textShadow: "1px 1px 2px grey",
                        }}
                            text="Wash - Dry & Fold" onClick={this.goToWashDryFold}>
                            <label><FaPlusSquare size={40} /> WASH - DRY & FOLD </label></span>
                    </div>
                    <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                            display: "inline-grid", fontWeight: "bold", color: "darkblue", backgroundColor: "beige", fontSize: "18px",
                            paddingTop: "20px"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToWashDryIron}>
                            <label ><FaPlusSquare size={40} /> WASH - DRY - IRON - FOLD</label></span>
                    </div>

                    <div style={{ paddingTop: "1px", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                            backgroundColor: "#FAF9F6", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                            paddingTop: "20px"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToTrackOrder}>
                            <label ><GrStatusGood size={40} /> TRACK ORDER</label></span>
                    </div>

                    <div style={{ paddingTop: "1px", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                            backgroundColor: "beige", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                            paddingTop: "20px"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToPricelist}>
                            <label ><MdOutlinePriceChange size={40} /> OUR PRICELIST</label></span>
                    </div>
                    <div id="viewEditOrders" style={{
                        display: this.props.location.state.role === 'Admin' ? 'inline-block' : 'none', borderRadius: "10px",
                        justifyContent: "center"
                    }} >
                        <div style={{ paddingTop: "1px", height: "120px", alignItems: "center" }}>
                            <span style={{
                                borderBottom: "2px solid grey",
                                borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                                backgroundColor: "#FAF9F6", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                                paddingTop: "20px"
                            }} text="Wash - Dry, Fold & Iron" onClick={this.goToDashboard}>
                                <label ><LayoutDashboard size={40} /> DASHBOARD</label></span>
                        </div>
                        <div style={{ paddingTop: "1px", height: "120px", alignItems: "center" }}>
                            <span style={{
                                borderBottom: "2px solid grey",
                                borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                                backgroundColor: "beige", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                                paddingTop: "20px"
                            }} text="Wash - Dry, Fold & Iron" onClick={this.goToOrders}>
                                <label ><GrView size={40} /> VIEW EDIT ORDERS</label></span>
                        </div>

                    </div>

                    {/* <div style={{ paddingTop: "10px", paddingBottom: "1vh", borderRadius: "10px", display: "flex", gap: "1rm" }}>
                        <Button style={{
                            marginRight: "5px", height: "160px", paddingLeft: "5px", width: "50%", border: '3px solid white', backgroundColor: "darkgrey",
                            backgroundImage: `url(${washDryFold})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover",
                            fontWeight: "bold", color: "#F5F5F5", fontSize: "18px", fontStyle: "italic"
                        }} text="Wash - Dry & Fold" onClick={this.goToWashDryFold}>
                        </Button>
                        <Button style={{
                            height: "160px", paddingLeft: "5px", width: "50%", border: '3px solid white',
                            backgroundImage: `url(${washdryironfold})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover",
                            fontWeight: "bold", color: "white", backgroundColor: "lightgrey", fontSize: "18px", fontStyle: "italic"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToWashDryIron}>
                            <span style={{ color: "white", paddingTop: "80px" }}><label >WASH-DRY-IRON-FOLD</label></span></Button>
                    </div>
                    <div style={{ paddingTop: "1vh", paddingBottom: "1vh", borderRadius: "10px", display: "flex", gap: "1rm" }}>
                        <Button style={{
                            marginRight: "5px", height: "160px", paddingLeft: "5px", width: "50%", background: "none", border: '3px solid white',
                            backgroundImage: `url(${ironFoldonly})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                            backgroundColor: "#0c0b07ff", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic"
                        }} text="Wash - Dry & Fold" onClick={this.goToIronFoldOnly}>IRON-FOLD ONLY</Button>
                        <Button style={{
                            height: "160px", paddingLeft: "5px", width: "50%",
                            backgroundImage: `url(${trackOrder})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", border: '3px solid white', fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic"
                        }} text="Track Order" onClick={this.goToTrackOrder}></Button>
                    </div>
                    <div style={{ paddingTop: "1vh", fontSize: "15px" }}>
                        <div style={{ paddingBottom: "1vh", borderRadius: "10px", display: "flex", gap: "1rm" }}>
                            <Button style={{
                                marginRight: "5px", height: "160px", paddingLeft: "5px", width: "50%",
                                backgroundImage: `url(${priceList})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                border: '3px solid white', fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic"
                            }} text="Our Price List" onClick={this.goToPricelist}></Button>
                            <Button style={{
                                height: "160px", paddingLeft: "5px", width: "50%",
                                backgroundImage: `url(${logout})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                border: '3px solid white',
                                fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic"
                            }} text="" onClick={() => this.openLogOut()}></Button>
                        </div>
                       
                        <div id="viewEditOrders" style={{
                            display: this.props.location.state.role === 'Admin' ? 'inline-block' : 'none', paddingBottom: "2px", borderRadius: "10px", gap: "1rm",
                            justifyContent: "center"
                        }}><div>
                                <Button style={{
                                    height: "80px", marginRight: "5px", paddingLeft: "5px", width: "49%", border: '3px solid white', backgroundColor: "#88b6e0",
                                    fontWeight: "bold", color: "#F5F5F5", fontSize: "18px",
                                }} text="View - Edit Orders" onClick={this.goToOrders}><BsPencil size={30} color="white" />View & Edit Orders</Button>
                                <Button style={{
                                    height: "80px", paddingLeft: "20px", width: "49%", border: '3px solid white',
                                    fontWeight: "bold", fontSize: "18px", color: "#F5F5F5", backgroundColor: "#88b6e0"
                                }} text="" onClick={this.goToDashboard}>
                                    <LayoutDashboard style={{ paddingLeft: "5px", fontStyle: "italic" }} size={35} color="white" />Dashboard
                                </Button>
                            </div>
                        </div> */}
                    {/* </div> */}
                    <div style={{
                        marginTop: "5%", borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                        backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "5px", paddingBottom: "20px"
                    }}>
                        <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                        <div>
                            <Button style={{
                                backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                fontWeight: "bold", textDecoration: "underline"
                            }}
                                onClick={this.openAbout}>About Us
                            </Button>
                            | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>
                        </div>
                    </div>
                    <div>
                        <Logout
                            ref={this.handleLogOutOpen}
                            confirmLogout={this.confirmLogout}
                        />
                        <About
                            ref={this.handleAboutOpen}
                            onAboutClose={this.onAboutClose}
                        />
                    </div>
                </div>

            </>)

    }
}
export default withNavigateHook(Home);